<template>
  <v-row id="subscription" class="ma-0" justify="center">
    <v-col cols="12" md="10" lg="9">
      <component
        :id="currentComponent"
        :is="currentComponent"
        @back="onBack"
        @next="onNext"
      ></component>
    </v-col>
  </v-row>
</template>

<script>
import SubscriptionIntroduction from '@/components/subscription/SubscriptionIntroduction';
import SubscriptionProducts from '@/components/subscription/SubscriptionProducts';
import SubscriptionDeliveryPickUp from '@/components/subscription/SubscriptionDeliveryPickUp';
import SubscriptionFrequency from '@/components/subscription/SubscriptionFrequency';
import SubscriptionOverview from '@/components/subscription/SubscriptionOverview';

export default {
  name: 'Subscription',
  components: {
    SubscriptionIntroduction,
    SubscriptionProducts,
    SubscriptionDeliveryPickUp,
    SubscriptionFrequency,
    SubscriptionOverview,
  },
  data() {
    return {
      currentComponent: 'SubscriptionIntroduction',
    };
  },
  mounted() {
    this.scrollToTop();
  },
  methods: {
    onBack() {
      switch (this.currentComponent) {
        case 'SubscriptionIntroduction':
          // Back to previous route
          this.$router.go(-1);
          break;
        case 'SubscriptionProducts':
          // Back to introduction page
          this.currentComponent = 'SubscriptionIntroduction';
          break;
        case 'SubscriptionFrequency':
          // Show products selection
          this.currentComponent = 'SubscriptionProducts';
          break;
        case 'SubscriptionDeliveryPickUp':
          // Back to repetition frequency selection
          this.currentComponent = 'SubscriptionFrequency';
          break;
        case 'SubscriptionOverview':
          // Back to delivery / pickup selection
          this.currentComponent = 'SubscriptionDeliveryPickUp';
          break;
        default:
          break;
      }

      this.scrollToTop();
    },
    onNext() {
      switch (this.currentComponent) {
        case 'SubscriptionIntroduction':
          // Proceed to products selection
          this.currentComponent = 'SubscriptionProducts';
          break;
        case 'SubscriptionProducts':
          // Proceed to repetition frequency selection
          this.currentComponent = 'SubscriptionFrequency';
          break;
        case 'SubscriptionFrequency':
          // Proceed to delivery / pickup selection
          this.currentComponent = 'SubscriptionDeliveryPickUp';
          break;
        case 'SubscriptionDeliveryPickUp':
          // Proceed to subscription overview
          this.currentComponent = 'SubscriptionOverview';
          break;
        case 'SubscriptionOverview':
          // Subscription creation completed, back to home page
          this.$router.push({ name: 'Homepage' });
          break;
        default:
          break;
      }

      this.scrollToTop();
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    },
  },
};
</script>
